module.exports = __webpack_public_path__ + "images/pages/for_business/sp/btn_3_1cb2879ad90168f6d6fb19a3430df809.png";